import {route, routes} from "../rd";
import {$shutils} from "../../libs/snnh/snnh";

export default class JSIBase {
    /**
     * 로그메세지
     * @param str
     */
    jsi_delog(str)
    {
    }

    /**
     * 종료여부 확인
     */
    jsi_is_exit()
    {
    }

    /**
     * 다운로드 속도
     * @param speed 정수형 문자(0, 100, 1000)
     */
    jsi_set_preload_speed(speed)
    {
    }

    /**
     * 다운로드 속도
     */
    jsi_get_preload_speed()
    {
    }

    /**
     * 스크린 가로
     * @returns {int}
     */
    jsi_get_screen_width()
    {
    }

    /**
     * 스크린 세로
     * @returns {int}
     */
    jsi_get_screen_height()
    {
    }

    /**
     * Setter: 윈도우 모드 설정
     * CRM: 플레이어 스킨모드 normal, mini
     * @param wmode
     * callJavaScript(m_wv_contents, "on_follow_pm", "m_window_mode", wmode);
     */
    jsi_set_window_mode(wmode)
    {
    }

    /**
     * 플레이어 재실행
     */
    jsi_restart()
    {
    }


    /**
     * 리부팅
     */
    jsi_reboot()
    {
    }


    /**
     * 종료
     */
    jsi_exit()
    {
    }

    /**
     * 크기조정
     */
    jsi_show()
    {
    }

    /**
     * 입력 가능
     */
    jsi_enable_input()
    {

    }

    /**
     * 입력 불가
     */
    jsi_disable_input()
    {

    }

    /**
     * 디바이스 존재여부 확인
     * @param cdx
     */
    jsi_check_device_exist(cdx)
    {
    }

    /**
     * 스크립트 오류 노출
     */
    jsi_show_script_error()
    {
    }

    /**
     * 스크립트 오류 미노출
     */
    jsi_hide_script_error()
    {
    }

    /**
     * 스크립투 오류 노출 여부
     * @returns {boolean}
     */
    jsi_is_show_script_error()
    {
    }


    /**
     * 디바이스 리스트
     * @returns {string}
     */
    jsi_get_device_list()
    {
    }

    /**
     * 디바이스 현재 정보
     * @param cdx
     * @returns {*}
     */
    jsi_get_device_now(cdx)
    {

    }


    /**
     * 디바이스 현재설정
     * @param cdx 인덱스
     * @param device_name 디바이스명
     * @param is_asio asio 여부
     * @param device_no 디바이스번호
     * @param device_ch 디바이스채널
     * @returns {boolean}
     */
    jsi_set_device_now(cdx, device_name, is_asio, device_no, device_ch)
    {

    }

    /**
     * 네트워크 상태
     * @returns {number} 0,1,-1
     */
    jsi_network_state()
    {
        return 1;
    }

    /**
     * ip로 핑
     * @param ip
     * @returns {number} 1, 0, -1(오류)
     */
    jsi_ping(ip)
    {
    }


    /**
     * 자바스크립트 호출
     * @param page 페이지 또는 함수
     * @param cb 콜백 함수
     * callJavaScript(m_wv_contents, "on_load", page, cb);
     */
    jsi_on_load(page, cb)
    {
    }

    /**
     * 파일정보
     * @param seq
     * @param ctype
     * @param ptype
     * @param channel
     * @param code
     * callJavaScript(m_wv_contents, "on_follow_file_info", path, filesize, ex ? "Y" : "N")
     */
    jsi_get_file_info(seq, ctype, ptype, channel, code)
    {
    }

    /**
     * 파일리스트
     * @param folder
     * @returns {*|string}
     */
    jsi_get_filelist(folder)
    {
    }


    /**
     * 로그파일 삭제
     * @param filename
     * @returns {boolean}
     */
    jsi_rmlog(filename)
    {
    }

    /**
     * 시스템로그 전송 설정
     * @param is_use
     */
    jsi_set_send_system_log(is_use)
    {
    }

    /**
     * 시스템로그 전송
     */
    jsi_get_send_system_log()
    {
    }

    /**
     * 시스템로그 저장 설정
     * @param is_use
     */
    jsi_set_save_system_log(is_use)
    {
    }

    /**
     * 시스템로그 저장 설정
     */
    jsi_get_save_system_log()
    {
    }

    /**
     * 시스템로그 노출
     * @param is_use
     */
    jsi_set_show_system_log(is_use)
    {
    }

    /**
     * 시스템 로그 데이터
     * @returns {*}
     */
    jsi_get_system_log()
    {
    }

    /**
     * Http Call 갯수
     * @param name
     * @returns {*}
     */
    jsi_count_http_call_by_name(name)
    {
    }

    /**
     * Http Call URL 갯수
     * @returns {*}
     */
    jsi_count_http_call_url()
    {
    }

    /**
     * Http Call Result 갯수
     * @returns {*}
     */
    jsi_count_http_call_res()
    {

    }

    /**
     * Http Call Save
     * @param name
     * @param url
     * @param save_result
     * @returns {*|string}
     */
    jsi_add_http_call(name, url, save_result)
    {
    }

    /**
     * Http Call
     * @param key
     * @returns {string}
     */
    jsi_get_http_call(key)
    {
    }

    /**
     * 재생로그 업로드 설정
     * @param is_use
     */
    jsi_set_playlog_upload(is_use)
    {
    }

    /**
     * 재생로그 업로드여부
     * @returns {*}
     */
    jsi_get_playlog_upload()
    {
    }

    /**
     * 재생목록 업로드 주소 설정
     * @param url
     */
    jsi_set_playlog_upload_url(url)
    {
    }


    /**
     * Http 업로드 data와 folder,filename 동시에 전달
     * @param url 업로드 주소
     * @param data 업로드 데이터
     * @param folder 폴더 @appres|@appcfg|@applog
     * @param filename 파일명
     * @returns {*}
     */
    jsi_http_upload(url, data, folder, filename)
    {

    }

    /**
     * 설정파일 불러오기
     * @param filename
     * @returns {*}
     */
    jsi_import(filename)
    {
    }

    /**
     * 데이터 인코딩
     * @param data 데이터
     * @param enc_key 암호키
     */
    jsi_data_encode(data, enc_key)
    {
    }

    /**
     * 데이터 디코딩
     * @param data 데이터
     * @param enc_key 암호키
     * @returns {*}
     */
    jsi_data_decode(data, enc_key)
    {
    }


    /**
     * 인증코드 인출
     * @returns {*}
     */
    jsi_get_auth_code()
    {
    }

    /**
     * 인증코드 재생성
     * @returns {*}
     */
    jsi_change_auth_code()
    {
    }

    /**
     * 아이디 설정
     * @param data
     */
    jsi_set_id(data)
    {
    }

    /**
     * 맥어드레스 설정
     * @param data
     */
    jsi_set_mac(data)
    {
    }

    /**
     * 서비스아이디 인출
     * @returns {*}
     */
    jsi_get_serviceid()
    {
    }

    /**
     * 자바스크립트 호출
     * @param str
     */
    jsi_call(str)
    {

    }

    /**
     * 이벤트 호출
     * @param type
     * @param data
     */
    jsi_event(type, data)
    {

    }

    /**
     * 페이지 이동
     * @param frame_name 페이지명
     * @param frame_url 페이지 주소
     */
    jsi_navigate(frame_name, frame_url)
    {
    }

    /**
     * 페이지 리로드
     * @param frame_name
     */
    jsi_reload(frame_name)
    {
    }


    /**
     * 히스토리 설정
     * @param max_size
     */
    jsi_init_history(max_size)
    {
    }

    /**
     * 히스토리 추가
     * @param history
     */
    jsi_add_history(history)
    {
    }

    /**
     * 마지막 히스토리
     * @returns {*}
     */
    jsi_get_last_history()
    {
    }

    /**
     * 히스토리 인출
     * @returns {string}
     */
    jsi_get_history()
    {
    }

    /**
     * 스펙트럼 설정
     * @param x
     * @param y
     * @param w
     * @param h
     */
    jsi_spectrum_init(x, y, w, h)
    {
    }

    /**
     * 스펙트럼 색상
     * @param r
     * @param g
     * @param b
     */
    jsi_spectrum_color(r, g, b)
    {
    }

    /**
     * 스펙트럼 노출
     */
    jsi_spectrum_show()
    {
    }

    /**
     * 스펙트럼 감추기
     */
    jsi_spectrum_hide()
    {

    }

    /**
     * 스펙트럼 노출 변경
     * @param mode {int}
     */
    jsi_spectrum_change(mode)
    {
    }

    /**
     * 스펙트럼 사용여부
     * @param mode {boolean}
     */
    jsi_spectrum_set_use(mode)
    {
    }

    /**
     * 스펙트럼 사용여부
     * @returns {*}
     */
    jsi_spectrum_get_use()
    {
    }

    /**
     * 스펙트럼 동작여부
     * @param cdx
     * @param idx
     * @returns {boolean}
     */
    jsi_is_spectrum_playing(cdx, idx)
    {
    }

    /**
     * 로그인
     * @param id 아이디
     * @param pw 비밀번호
     */
    jsi_login(id, pw)
    {
        route(routes.login_process_pw, id, pw);
    }

    /**
     * 로그아웃
     */
    jsi_logout()
    {
        route(routes.logout);
    }

    /**
     * 디바이스 정보
     * @returns {*}
     */
    jsi_get_info()
    {
        const duration = 148794.580499;
        const current = $shutils.random(1, Math.floor(duration));

        return 'm_initialized=\n' +
            'm_window_mode=\n' +
            'm_cpmode=\n' +
            'm_login=\n' +
            'm_network=\n' +
            'm_maintenance=\n' +
            'm_id=\n' +
            'm_volume_master=1.00\n' +
            'm_volume_bgm=1.00\n' +
            'm_volume_cm=1.00\n' +
            'm_volume_alert=1.00\n' +
            'm_volume_effect1=1.00\n' +
            'm_volume_effect2=1.00\n' +
            'm_volume_effect3=1.00\n' +
            'm_mute_on_bgm=false\n' +
            'm_mute_on_alert=false\n' +
            'm_mute_on_effect=false\n' +
            'm_mute_on_effect1=false\n' +
            'm_mute_on_effect2=false\n' +
            'm_mute_on_effect3=false\n' +
            'm_channel_id=41937\n' +
            'm_channel_name=최신 뉴에이지 피아노\n' +
            'm_shopid=\n' +
            'm_shopname=테스트김정은\n' +
            'm_serviceid=A0177432\n' +
            'm_mac=4ee628de9c3552f66204eed5cbed5c6f\n' +
            'm_current_stream=bgm\n' +
            'm_stream_bgm_at=00:18:34\n' +
            'm_stream_bgm_id=SM00000985209\n' +
            'm_stream_bgm_title=잔잔한 노래 (회상)\n' +
            'm_stream_bgm_current=' + current + '\n' +
            'm_stream_bgm_duration=' + duration + '\n' +
            'm_stream_ucmt_at=\n' +
            'm_stream_ucmt_id=\n' +
            'm_stream_ucmt_title=\n' +
            'm_stream_ucmt_current=0.000000\n' +
            'm_stream_ucmt_duration=0.000000\n' +
            'm_stream_cmt_at=\n' +
            'm_stream_cmt_id=\n' +
            'm_stream_cmt_title=\n' +
            'm_stream_cmt_current=0.000000\n' +
            'm_stream_cmt_duration=0.000000\n' +
            'm_stream_mcmt_at=\n' +
            'm_stream_mcmt_id=\n' +
            'm_stream_mcmt_title=\n' +
            'm_stream_mcmt_current=0.000000\n' +
            'm_stream_mcmt_duration=0.000000\n' +
            'm_stream_live_at=\n' +
            'm_stream_live_id=\n' +
            'm_stream_live_title=\n' +
            'm_stream_live_current=0.000000\n' +
            'm_stream_live_duration=0.000000\n' +
            'm_stream_cme_at=\n' +
            'm_stream_cme_id=\n' +
            'm_stream_cme_title=\n' +
            'm_stream_cme_current=0.000000\n' +
            'm_stream_cme_duration=0.000000\n' +
            'm_stream_effect1_at=\n' +
            'm_stream_effect1_id=\n' +
            'm_stream_effect1_title=\n' +
            'm_stream_effect1_current=0.000000\n' +
            'm_stream_effect1_duration=0.000000\n' +
            'm_stream_effect2_at=\n' +
            'm_stream_effect2_id=\n' +
            'm_stream_effect2_title=\n' +
            'm_stream_effect2_current=0.000000\n' +
            'm_stream_effect2_duration=0.000000\n' +
            'm_stream_effect3_at=\n' +
            'm_stream_effect3_id=\n' +
            'm_stream_effect3_title=\n' +
            'm_stream_effect3_current=0.000000\n' +
            'm_stream_effect3_duration=0.000000\n' +
            'm_stream_alert_at=\n' +
            'm_stream_alert_id=\n' +
            'm_stream_alert_title=\n' +
            'm_stream_alert_current=0.000000\n' +
            'm_stream_alert_duration=0.000000\n' +
            'm_stream_ad_at=\n' +
            'm_stream_ad_id=\n' +
            'm_stream_ad_title=\n' +
            'm_stream_ad_current=0.000000\n' +
            'm_stream_ad_duration=0.000000\n' +
            'm_stream_local_at=\n' +
            'm_stream_local_id=\n' +
            'm_stream_local_title=\n' +
            'm_stream_local_current=0.000000\n' +
            'm_stream_local_duration=0.000000\n' +
            'm_current=' + this.jsi_milliseconds();
    }

    /**
     * 볼륨 설정
     * @param name 사운드명
     * @param mode 모드 up|down|set
     * @param vol 볼륨값
     */
    jsi_set_volume(name, mode, vol)
    {
    }

    /**
     * 음소거
     * @param name 사운드명
     * @param mode 음소거 값 on|off
     */
    jsi_set_mute(name, mode)
    {
    }

    /**
     * 채널변경
     * @param channel_id 채널아이디(base64)
     * @param channel_name 채널명(base64)
     */
    jsi_change_channel(channel_id, channel_name)
    {
    }

    /**
     * 아이디 인출
     * @returns {*}
     */
    jsi_get_id()
    {
    }

    /**
     * 맥어드레스 인출
     * @returns {*}
     */
    jsi_get_mac()
    {
    }

    /**
     * @returns {boolean}
     */
    jsi_is_play() {
        return false;
    }

    /**
     * @returns {boolean}
     */
    jsi_play() {

    }

    /**
     * @returns {boolean}
     */
    jsi_stop() {

    }

    /**
     * @param url
     * @param filename
     */
    jsi_download(url, filename) {
        this.jsi_open_browser(url, filename);
    }

    /**
     * @param url
     */
    jsi_open_browser(url) {
        window.open(url);
    }

    /**
     * @returns {*}
     */
    jsi_milliseconds() {
        return new Date().getTime();
    }

    /**
     * @returns {number}
     */
    jsi_gc() {

    }

    jsi_toast(message) {
        alert(message);
    }

    jsi_notification(message) {

    }

    jsi_set_page_code(code) {

    }
}



// Interface.jsi_spectrum_color("<?=$r?>", "<?=$g?>", "<?=$b?>");
// Interface.jsi_spectrum_set_use(true);
// Interface.jsi_spectrum_change(1);
// Interface.jsi_spectrum_show();
// Interface.jsi_spectrum_hide();
// Interface.jsi_get_window_mode();
// Interface.jsi_get_serviceid();
// Interface.jsi_set_device_now(0, "", false, -2, 0);
// Interface.jsi_get_str("pp_status", "");
// Interface.jsi_get_str("pp_end", "")
// Interface.jsi_get_filelist("@applog");
// Interface.jsi_rmlog(logname)
// Interface.jsi_enable_input();
// Interface.jsi_disable_input();
// Interface.jsi_show(0);
// Interface.jsi_restart();
// Interface.jsi_exit();
// Interface.jsi_get_bool('m_mute_on_master', false);
// Interface.jsi_get_bool('m_userstop', false);
// Interface.jsi_call("set_volume_up('"+speaker+"', " + volume + ")");
// Interface.jsi_call("set_volume_down('"+speaker+"', " + volume + ")");
// Interface.jsi_call("set_volume_set('"+speaker+"', " + volume + ")");
// Interface.jsi_call("play()")
// Interface.jsi_call("stop()")
// Interface.jsi_call("mute_off()");
// Interface.jsi_call("mute_on()");
// Interface.jsi_set_window_mode("mini");
// Interface.jsi_set_window_mode("");
// Interface.jsi_set_window_mode("wstb");
// Interface.jsi_get_screen_width();
// Interface.jsi_get_cpmode();
// Interface.jsi_get_float("m_volume_master", 1.0);
// Interface.jsi_get_float("m_volume_alertcm", 1.0);
// Interface.jsi_get_float("m_volume_effect1", 1.0);
// Interface.jsi_get_float("m_volume_effect2", 1.0);
// Interface.jsi_get_float("m_volume_effect3", 1.0);
// Interface.jsi_get_version();
// Interface.jsi_get_device_list();
// Interface.jsi_get_device_now(0);
// Interface.jsi_check_device_exist(0);
// Interface.jsi_get_long("playpos", 0);
// Interface.jsi_get_long("playtime", 0);
// Interface.jsi_get_play_info(0, 0, "info");
// Interface.jsi_get_play_info(0, 5, "info");
// Interface.jsi_get_play_info(0, 4, "info");
// Interface.jsi_get_play_info(0, 0, "channel");
// Interface.jsi_get_auth_code();
// Interface.jsi_get_id();
// Interface.jsi_get_mac();
// Interface.jsi_get_serviceid();
// Interface.jsi_change_auth_code();
// Interface.jsi_get_history();
// Interface.jsi_call("set_dev_mode_super(false)");
// Interface.jsi_call("set_dev_mode_super(true)");
// Interface.jsi_on_load('<?=$_PAGE_NAME?>', '<?=$_PAGE_CALLBACK?>');
// Interface.jsi_login($(f.id).val().toLowerCase(), $(f.password).val());


// WEBPACK FOOTER //
// ./src/vars/interfaces/base.js